// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
a.item {
  text-decoration: none;
  color: inherit;
  display: flex;
  cursor: pointer;
}
a.item:hover {
  text-decoration: none;
}
a.item:visited {
  color: inherit;
}

ion-avatar {
  width: calc(60 * var(--width-ratio));
  height: calc(60 * var(--width-ratio));
}

.slot-content {
  flex: 1;
  padding-top: calc(16 * var(--width-ratio));
  padding-bottom: calc(16 * var(--width-ratio));
  margin-left: calc(12 * var(--width-ratio));
  /* 關注 */
  /* 已關注 */
}
.slot-content .non-follow-btn {
  --background: var(--ion-color-primary-tint);
  width: calc(68 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
  margin: unset;
  --padding-end: unset;
  --padding-start: unset;
}
.slot-content .follow-btn {
  --background: white;
  --border-color: var(--ion-color-medium);
  --color: var(--ion-color-medium);
  --border-style: solid;
  --border-width: 1px;
  clear: both;
  width: calc(84 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
  margin: unset;
  --padding-end: unset;
  --padding-start: unset;
}
.slot-content .item-section {
  min-width: 150px;
}

.slot-end {
  flex-basis: calc(108 * var(--width-ratio));
}
.slot-end .buttons-div {
  width: 100%;
  height: calc(46 * var(--width-ratio));
  background: rgba(162, 146, 193, 0.1);
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  /* 關注 */
  /* 已關注 */
}
.slot-end .buttons-div .non-follow-btn {
  --background: var(--ion-color-primary-tint);
  width: calc(68 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
  margin-top: calc(2 * var(--width-ratio));
  margin-right: 26px;
  --padding-end: unset;
  --padding-start: unset;
}
.slot-end .buttons-div .follow-btn {
  --background: white;
  --border-color: var(--ion-color-medium);
  --color: var(--ion-color-medium);
  --border-style: solid;
  --border-width: 1px;
  margin: 2px 0 0 0;
  margin-right: 26px;
  clear: both;
  width: calc(84 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
  --padding-end: unset;
  --padding-start: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/expert-list-item/expert-list-item.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,qBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AACF;AACE;EACE,qBAAA;AACJ;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,oCAAA;EACA,qCAAA;AADF;;AAIA;EACE,OAAA;EACA,0CAAA;EACA,6CAAA;EACA,0CAAA;EAEA,OAAA;EAaA,QAAA;AAdF;AAEE;EACE,2CAAA;EACA,oCAAA;EACA,qCAAA;EAIA,aAAA;EACA,oBAAA;EACA,sBAAA;AAHJ;AAOE;EACE,mBAAA;EACA,uCAAA;EACA,gCAAA;EACA,qBAAA;EACA,mBAAA;EAGA,WAAA;EACA,oCAAA;EACA,qCAAA;EAEA,aAAA;EACA,oBAAA;EACA,sBAAA;AARJ;AAWE;EACE,gBAAA;AATJ;;AAaA;EACE,0CAAA;AAVF;AAYE;EACE,WAAA;EACA,qCAAA;EACA,oCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,OAAA;EAaA,QAAA;AAvBJ;AAWI;EACE,2CAAA;EACA,oCAAA;EACA,qCAAA;EAEA,wCAAA;EACA,kBAAA;EAEA,oBAAA;EACA,sBAAA;AAXN;AAeI;EACE,mBAAA;EACA,uCAAA;EACA,gCAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,oCAAA;EACA,qCAAA;EAEA,oBAAA;EACA,sBAAA;AAdN","sourcesContent":["// SEO 優化：將 item 從 div 改為 a 標籤，移除預設樣式\na.item {\n  text-decoration: none;\n  color: inherit;\n  display: flex;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:visited {\n    color: inherit;\n  }\n}\n\nion-avatar {\n  width: calc(60 * var(--width-ratio));\n  height: calc(60 * var(--width-ratio));\n}\n\n.slot-content {\n  flex: 1;\n  padding-top: calc(16 * var(--width-ratio));\n  padding-bottom: calc(16 * var(--width-ratio));\n  margin-left: calc(12 * var(--width-ratio));\n\n  /* 關注 */\n  .non-follow-btn {\n    --background: var(--ion-color-primary-tint);\n    width: calc(68 * var(--width-ratio));\n    height: calc(24 * var(--width-ratio));\n\n    // margin-top: calc(2 * var(--width-ratio));\n    // margin-right: 26px;\n    margin: unset;\n    --padding-end: unset;\n    --padding-start: unset;\n  }\n\n  /* 已關注 */\n  .follow-btn {\n    --background: white;\n    --border-color: var(--ion-color-medium);\n    --color: var(--ion-color-medium);\n    --border-style: solid;\n    --border-width: 1px;\n    // margin: 2px 0 0 0;\n    // margin-right: 26px;\n    clear: both;\n    width: calc(84 * var(--width-ratio));\n    height: calc(24 * var(--width-ratio));\n\n    margin: unset;\n    --padding-end: unset;\n    --padding-start: unset;\n  }\n\n  .item-section {\n    min-width: 150px;\n  }\n}\n\n.slot-end {\n  flex-basis: calc(108 * var(--width-ratio));\n\n  .buttons-div {\n    width: 100%;\n    height: calc(46 * var(--width-ratio));\n    background: rgba(162, 146, 193, 0.1);\n    border-top-left-radius: 40px;\n    border-bottom-left-radius: 40px;\n\n    /* 關注 */\n    .non-follow-btn {\n      --background: var(--ion-color-primary-tint);\n      width: calc(68 * var(--width-ratio));\n      height: calc(24 * var(--width-ratio));\n\n      margin-top: calc(2 * var(--width-ratio));\n      margin-right: 26px;\n\n      --padding-end: unset;\n      --padding-start: unset;\n    }\n\n    /* 已關注 */\n    .follow-btn {\n      --background: white;\n      --border-color: var(--ion-color-medium);\n      --color: var(--ion-color-medium);\n      --border-style: solid;\n      --border-width: 1px;\n      margin: 2px 0 0 0;\n      margin-right: 26px;\n      clear: both;\n      width: calc(84 * var(--width-ratio));\n      height: calc(24 * var(--width-ratio));\n\n      --padding-end: unset;\n      --padding-start: unset;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
